<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import Card from "../../../ui/components/cards/Card.vue";
import { computed, onBeforeMount, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import { useRoute } from "vue-router";
import RoleDO = App.Data.RoleDO;
import Logs from "../components/Logs.vue";
import { RouteGuards } from "@/router/guards";
import { useBaseStore } from "@/stores/base";

const store = useBaseStore();

const role: Ref<RoleDO | undefined> = ref();

const breadcrumbs = ref([
	{
		title: "Roles",
		disabled: false,
		to: "/roles",
	},
]);

const tabs: Ref<tabsType[]> = ref([]);

const loadRole = async () => {
	const uuid: string | string[] = useRoute().params.uuid ?? "";
	const response = await useApiClient("roles").getRoleByUUID(uuid);
	if (response.isOk()) {
		role.value = response.value;

		breadcrumbs.value.push({
			title: response.value.name,
			disabled: true,
			to: "",
		});

		tabs.value = [
			{
				itemId: "permissions",
				translationKey: "roles.detail.permissionTab",
				icon: "fa-list-check",
				to: `/roles/edit/${response.value.uuid}/permissions`,
			},
			{
				itemId: "general-settings",
				translationKey: "roles.detail.generalTab",
				icon: "fa-sliders",
				to: `/roles/edit/${response.value.uuid}/general-settings`,
			},
			{
				itemId: "favorite-dimensions",
				translationKey: "roles.detail.favoriteDimensionsTab",
				icon: "fa-thumbtack",
				to: `/roles/edit/${response.value.uuid}/favorite-dimensions`,
			},
		];
	}
};

onBeforeMount(async () => {
	await loadRole();
});

type tabsType = {
	itemId: string;
	translationKey: string;
	icon: string;
	to: string;
};

const updateRole = (updatedRole: App.Data.RoleDO) => {
	breadcrumbs.value[breadcrumbs.value.length - 1].title = updatedRole.name;
	role.value = updatedRole;
};

const activeTab = ref(null);
</script>

<template>
	<main-breadcrumbs
		:breadcrumbs="breadcrumbs"
		v-if="role"
		:key="role.name ?? 0"
	/>

	<v-tabs v-model="activeTab" class="rounded-md">
		<v-tab
			v-for="(tab, index) in tabs"
			v-show="
				RouteGuards.hasPermissions({
					to: RouteGuards.getRouteByPath(tab.to),
					store,
				})
			"
			:value="tab.itemId"
			:to="tab.to"
			:key="index"
		>
			<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
			<div class="tab-text">
				{{ $t(tab.translationKey) }}
			</div>
		</v-tab>
	</v-tabs>
	<v-divider />
	<v-card-text class="pa-0">
		<router-view v-if="role" :role="role" @update-role="updateRole" />
	</v-card-text>
</template>

<style lang="scss"></style>
